import { ReactNode } from 'react';
import { ClickAwayProps, ScrollAwayProps } from '@optimus-web/helpers';
import { IconName } from '@optimus-web/icons';
import { IconButtonVariant } from '@optimus-web/local-tokens';
import { ElementOrElementGetter, SizeType } from '../types';

export interface MenuProps {
    children: ReactNode;
    opened: boolean;
    focusListOnOpen?: boolean;
    anchorElement?: ElementOrElementGetter;
    portalContainerId?: string;
    scrollable?: boolean;
    sizeToAnchor?: boolean;
    showAsDialog?: boolean;
    onClose?: (event: React.MouseEvent) => void;
    forwardedRef?: React.Ref<HTMLDivElement>;
    overlayMinWidth?: number;
    placement?: 'bottom-start' | 'bottom-end' | 'top-start' | 'top-end';
}

export interface IconMenuProps extends ClickAwayProps, ScrollAwayProps {
    icon: IconName;
    children?: ReactNode;
    className?: string;
    buttonVariant?: IconButtonVariant;
    buttonSize?: SizeType;
    forwardedRef?: React.Ref<HTMLDivElement>;
    overlayMinWidth?: number;
    placement?: 'bottom-start' | 'bottom-end' | 'top-start' | 'top-end';
}
